export const RouteGetPogAnalysis_OutputStorePogId_ = "/pog-analysis/:outputStorePogId";

export interface ParamsGetPogAnalysis_OutputStorePogId_ {
  outputStorePogId: string;
}

export interface ResponseGetPogAnalysis_OutputStorePogId_ {
  output_store_pog_id: number;
  total_expected_sales: number;
  uplift: number;
  analysis_summary: {
    efficiency_score: number;
    space_utilization: number;
    cdt_distribution: {
      distribution_type: string;
      segments: Array<{
        segment: string;
        // Space vs sales semantics at CDT0 (variant)
        sales_mix_pct: number;
        space_mix_pct: number;
        current_width_pct: number;
        percentage_delta: number;
        threshold: number;
        threshold_met: number;
      }>;
      space_mix_compliance: number;
      threshold_percentage: number;
      segments_meeting_threshold: number;
      total_segments: number;
    };
    total_items: number;
    total_bays: number;
    total_shelves: number;
    pog_overview: string;
    key_strengths: Array<{
      title: string;
      description: string;
      impact: string;
    }>;
    critical_weaknesses: Array<{
      title: string;
      description: string;
      impact: string;
    }>;
    efficiency_drivers: string;
    optimization_potential: string;
    evaluation_criteria: {
      space_utilization_score: number;
      cdt_distribution_score: number;
      performance_target_score: number;
      constraint_compliance_score: number;
    };
  };
  recommendations: Array<{
    category: string;
    priority: string;
    items: Array<{
      title?: string;
      what?: string;
      where?: string;
      current_state?: string;
      proposed_state?: string;
      why?: string;
      expected_result?: string;
      implementation_complexity?: string;
      item_name?: string;
      current_location?: string;
      current_facings?: number;
      recommended_facings?: number;
      reason?: string;
      expected_impact?: string;
    }>;
  }>;
  generated_at: string;
}
